import { PropsWithChildren } from 'react';
import styles from './FieldComponent.module.scss';

export interface FieldProps {
	title: string;
}
export const FieldComponent = (props: PropsWithChildren<FieldProps>) => {
	return (
		<div className={styles.container}>
			<div className={styles.label}>{props.title}</div>
			{props.children}
		</div>
	)
}